module.exports = __webpack_public_path__ + "static/media/0009.90cb1c73.jpg";